import { PLANT_HREF } from '@atbash-labs/plantview-links'
import { useGetAuthzMeQuery } from '@axilon-apps/domains-ontology-ui-state'
import { NotFoundPage } from '@axilon-apps/libs-ui-dashboard'

interface IngestRouteProps {
  children: React.ReactNode
}

/**
 * Wrapper for ingestion pages, which are admin-only. Renders `children` only
 * with `ingest/read`, nothing while the authorization snapshot loads or
 * refreshes (View As), and the standard `NotFoundPage` otherwise.
 */
export function IngestRoute({ children }: IngestRouteProps) {
  const { data: authz, isError, isFetching, isLoading } = useGetAuthzMeQuery()
  if (isLoading || isFetching) return null
  if (isError || !authz?.permissions.includes('ingest/read')) {
    return <NotFoundPage href={PLANT_HREF.root} />
  }
  return children
}

export default IngestRoute
